import register from "preact-custom-element";
import c from "classnames";
import { useEffect, useState } from "preact/hooks";

import pauseImg from "@/assets/images/video-pause.svg";
import playImg from "@/assets/images/video-play.svg";
import { createRef } from "preact";

function VideoCtl(props) {
  const settings = JSON.parse(decodeURIComponent(props.settings));
  const [play, setPlay] = useState(false);
  const videoRef = createRef();

  useEffect(() => {
    if (play) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [play]);

  return (
    <div className={c("relative w-full h-full")}>
      <div className="absolute top-16 z-10 right-30 rounded-20 w-46 h-46">
        <img
          src={play ? pauseImg : playImg}
          className="w-full h-full"
          onClick={() => setPlay(!play)}
          alt=""
        />
      </div>
      <video
        ref={videoRef}
        className={c(
          "rounded-20",
          props.cover === "true"
            ? "w-full h-full object-cover"
            : "w-full h-full object-contain",
        )}
        src={settings?.sources[1]?.url || settings?.sources[0]?.url}
      >
        {settings?.sources?.map((item) => (
          <source key={item.url} src={item.url}></source>
        ))}
      </video>
    </div>
  );
}

register(VideoCtl, "video-ctl");
